type GeneralStore = {
  appBootParams?: Record<string, string>;
};

export const generalStore: GeneralStore = {};
